import axios from "axios";
import { Guide, GuideContent, GuidesResponse, UploadResponse } from "@/api/types";

export const getGuides = (filter: string) => axios.get<GuidesResponse>('guides', { params: { filter } });
export const getGuide = (id: string) => axios.get<Guide>(`guides/${ id }`);
export const deleteGuide = (id: number) => axios.delete(`guides/${ id }`);
export const deleteImage = (path: string) => axios.delete('guides/upload', { data: { path } });
export const createGuide = (title: string, type: string, body: Array<GuideContent>, staffOnly: boolean, supportEnabled = false) =>
    axios.post('guides/create', { title, type, body, staff_only: staffOnly, support_enabled: supportEnabled });
export const updateGuide = (id: number, title: string, type: string, body: Array<GuideContent>, staffOnly: boolean, supportEnabled = false) =>
    axios.put(`guides/${ id }`, { title, type, body, staff_only: staffOnly, support_enabled: supportEnabled });
export const uploadImage = (file: File) => {
    const formData = new FormData();
    formData.append('image', file);
    return axios.post<UploadResponse>('guides/upload', formData, {
        headers: { "Content-Type": "multipart/form-data", }
    });
}
